// utils/pinModal.tsx
import { X } from "lucide-react";

import load from "./assets/load.gif"; // Adjust path
import PaymentPin from "./PaymentPin";

interface PinModalProps {
    isVisible?: boolean;
    title: string;
    description: string;
    code?: string[];
    onCodeChange: (code: string[]) => void;
    onSubmit: () => void;
    onCancel: () => void;
    loading: boolean;
}

const PinModal: React.FC<PinModalProps> = ({
    isVisible = false,
    title,
    description,
    code = Array(4).fill(""),
    onCodeChange,
    onSubmit,
    onCancel,
    loading,
}) => {
    return (
        <>
            {isVisible && (
                <div className="w-full h-full bg-[#1212128d] z-[999] fixed top-0 left-0 p-6 flex justify-center items-center">
                    <div className="bg-[#FFFFFF] p-6 rounded-[15px] w-full md:w-[600px]">
                        <div className="w-full bg-white">
                            <span className="flex items-center justify-between">
                                <p className="text-[#272D37] font-semibold font-Manrope text-lg md:text-xl">
                                    {title}
                                </p>
                                <X className="cursor-pointer" onClick={onCancel} />
                            </span>
                            <p className="font-Manrope text-[#5F6D7E] font-normal text-sm md:text-base mt-2">
                                {description}
                            </p>
                            <div className="w-full overflow-y-auto max-h-[400px] pr-2 flex flex-col items-center mt-6 font-Manrope">
                                <PaymentPin
                                    code={code}
                                    onCodeChange={onCodeChange}
                                    forgot={true}
                                />
                            </div>
                            <div className="mt-6 w-full grid grid-cols-2 gap-4 md:gap-6">
                                <button
                                    onClick={onCancel}
                                    className="border border-[#DAE0E6] rounded-md py-3 font-Manrope text-[#272D37] font-semibold text-base"
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={onSubmit}
                                    disabled={loading}
                                    className={`rounded-md py-3 font-Manrope text-[#fff] font-semibold text-base flex justify-center items-center ${loading
                                            ? "bg-[#317333]/50 cursor-not-allowed"
                                            : "bg-[#317333]"
                                        }`}
                                >
                                    {loading ? (
                                        <img src={load} className="w-5" alt="Loading" />
                                    ) : (
                                        "Confirm"
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default PinModal;
